import { IResponse, IResponsePagination } from '@/types/common';
import {
  ICreateFukumaruQuizRequest,
  IGetListFukumaruQuizRequest,
  IUpdateFukumaruQuizRequest,
} from '@/types/request/fukumaruQuiz';
import {
  IGetDetailFukumaruQuizResponse,
  IGetListFukumaruQuizResponse,
} from '@/types/response/fukumaruQuiz';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class FukumaruQuiz {
  getList = (
    params: IGetListFukumaruQuizRequest,
  ): Promise<IResponsePagination<IGetListFukumaruQuizResponse>> => {
    return axiosClient.get(ENDPOINT.FUKUMARU_QUIZ.GET_LIST, { params });
  };

  getDetail = (
    id: number,
  ): Promise<IResponse<IGetDetailFukumaruQuizResponse>> => {
    return axiosClient.get(
      ENDPOINT.FUKUMARU_QUIZ.GET_DETAIL.replace(':id', String(id)),
    );
  };

  create = (
    body: ICreateFukumaruQuizRequest,
  ): Promise<IResponse<IGetDetailFukumaruQuizResponse>> => {
    return axiosClient.post(ENDPOINT.FUKUMARU_QUIZ.CREATE, body);
  };

  update = (
    data: IUpdateFukumaruQuizRequest,
    id: number,
  ): Promise<IResponse<IGetDetailFukumaruQuizResponse>> => {
    return axiosClient.put(
      ENDPOINT.FUKUMARU_QUIZ.UPDATE.replace(':id', String(id)),
      data,
    );
  };

  delete = (id: number) => {
    return axiosClient.delete(
      ENDPOINT.FUKUMARU_QUIZ.DELETE.replace(':id', String(id)),
    );
  };
}

export const FukumaruQuizService = new FukumaruQuiz();
